exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-application .footerpart{border-top:1px solid rgba(0,0,0,.1)!important}.theme--light.v-footer{background:#fff}", ""]);

// exports
